import React, { useEffect, useState } from "react";
import PropTypes, { element } from "prop-types";
import { useSelector, useDispatch } from "react-redux";

// import router link
import { Link, useHistory, useLocation } from "react-router-dom";

// import store
import { connect } from "react-redux";

// import store actions
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setArticle,
  setFormation,
  togglePreloader,
} from "../../store/actions";

// import deep-equal
import equal from "deep-equal";

// import moment
import moment from "moment";
import "moment/locale/fr";

// import services
import { getArticle, getOpportunity } from "../../services/opportunityService";
import {
  getAllArticles,
  getAllArticlesCategory,
  postCategoryIdByArticles,
} from "../../services/articleService";
import { getFormation } from "../../services/formationService";

// import dummies
import { OPPORTUNITY } from "../../helpers/dummies";

// import common components
import Banner from "../../components/common/Banner";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Section from "../../components/common/Section";
import Square from "../../components/common/Square";

// import constants
import { APP_TOKEN } from "../../helpers/constants";

// import utilities
import { isUnauthenticatedRequest } from "../../helpers/utilities";
import articleImage from "../../assets/images/article-sideImage.png";
import cardImages from "../../assets/images/article-cards.png";
import ListArticle from "../../components/custom/articles/ListArticle";
import ArticleList from "../../components/custom/articles/ArticleList";

export default function NewArticle() {
  const location = useLocation();
  const { state } = location;
  const dispatch = useDispatch();
  const isPreloader = useSelector((state) => state.isPreloader);
  const publicId = useSelector((state) => state.publicId);
  const history = useHistory();
  const [data, setData] = useState([]);
  const [category, setCategory] = useState([]);
  const [email, setEmail] = useState("");

  // useEffect(()=>{
  //   const fetchData = async () => {
  //     dispatch(togglePreloader(true, "Chargement"));
  //     if (!localStorage.getItem(APP_TOKEN)) {
  //       dispatch(setAppTokenAsked(true));
  //     } else {
  //       await onGetSettings();
  //     }
  //   };
  //   fetchData();
  // },[dispatch])

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0); // Scroll to the top of the page when route changes
    });

    return () => {
      unlisten(); // Cleanup the listener when the component unmounts
    };
  }, [history]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getAllArticles();
        const resData = await getAllArticlesCategory(state.code);
        // console.log({resData})
        if (res && res.data) {
          // const categoryData = res.data.map((val) => ({
          //   // id: val.category,
          //   categoryName: val.categoryName
          //     ? val.categoryName
          //     : "Etudes longues",
          //   id: val.publicId,
          // }));
          const categoryData = resData.itemCategories.map((val) => ({
            // id: val.category,
            categoryName: val.title ? val.title : "Etudes longues",
            id: val.id,
          }));

          const articles = resData.item.map((ele) => ({
            id: ele.id,
            title: ele.title,
            description: ele.description,
            author: ele.author || "name",
            image: ele.image || "png",
            publicId: ele.publicId,
          }));

          setCategory(categoryData);
          setData(articles);
        }
      } catch (err) {
        console.error(err);
        // Handle errors gracefully, e.g., show an error message to the user
      }
    };

    // Fetch data when the component mounts
    fetchData();
  }, []);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can perform any validation or further processing before storing the email
    console.log("Email submitted:", email);
    // Reset the email input after submission if needed
    setEmail("");
  };

  const handleArticlesChange = async (e, id) => {
    // e.preventDefault();
    // console.log(e.target)
    const resData = await postCategoryIdByArticles({
      categoryId: id,
    });
    if (resData) {
      console.log({ resData });
      const articles = resData.data.map((ele) => ({
        id: ele.id,
        title: ele.title,
        description: ele.description,
        author: ele.author || "name",
        image: ele.image || "png",
        publicId: ele.publicId,
      }));
      setData(articles);
    } else {
      const res = await getAllArticles();
      const resData = await getAllArticlesCategory(state.code);
      // console.log({resData})
      if (res && res.data) {
        // const categoryData = res.data.map((val) => ({
        //   // id: val.category,
        //   categoryName: val.categoryName
        //     ? val.categoryName
        //     : "Etudes longues",
        //   id: val.publicId,
        // }));
        const categoryData = resData.itemCategories.map((val) => ({
          // id: val.category,
          categoryName: val.title ? val.title : "Etudes longues",
          id: val.id,
        }));

        const articles = resData.item.map((ele) => ({
          id: ele.id,
          title: ele.title,
          description: ele.description,
          author: ele.author || "name",
          image: ele.image || "png",
          publicId: ele.publicId,
        }));

        setCategory(categoryData);
        setData(articles);
      }
    }
  };

  return (
    <React.Fragment>
      <div id="home-page" className={`${isPreloader ? "d-none" : "d-block"}`}>
        <section className="container">
          <div className="blog-sec">
            <div className="row">
              <div className="col-lg-6">
                <div className="blog-content">
                  <h1>
                    Ace Orientation <br /> articles
                  </h1>
                  <p>
                    Entrez votre e-mail pour vous abonner à la newsletter ACE et
                    rester à jour avec les meilleures universités et
                    opportunités. Entrez votre e-mail pour vous abonner à la
                    newsletter ACE et rester à jour avec les meilleures
                    universités et opportunités.Entrez votre e-mail pour vous
                    abonner à la newsletter .
                  </p>
                  <p>E-mail adress</p>
                  <form class="form-inline">
                    <div class="form-group">
                      <input
                        type="email"
                        class="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        placeholder="Tapez votre e-mail"
                        value={email}
                        onChange={handleChange}
                      />
                      <button
                        type="submit"
                        class="submit-btn"
                        onClick={handleSubmit}
                      >
                        S'abonner
                      </button>
                    </div>
                  </form>
                  {/* <div className="blog-button">
                    <div>
            
                      <button type="button">Tapez votre e-mail</button> 
                       <button type="button">S'abonner</button>  */}
                  {/* </div>
                  </div> */}
                  <p>
                    {" "}
                    By clicking this button I agree to the
                    <span style={{ marginLeft: "5px" }}>
                      <a href="#" className="text-decoration-underline">
                        Terms of Service
                      </a>
                    </span>
                    <span style={{ marginLeft: "5px" }}>and</span>
                    <span style={{ marginLeft: "5px" }}>
                      <a href="#" className="text-decoration-underline">
                        Privacy Policy
                      </a>
                    </span>
                    {/* <span><a href="#" class="text-decoration-underline"> Terms of Service</a> </span> and 
                     <span><a  href="#" class="text-decoration-underline"> Privacy Policy.</a></span> */}
                  </p>
                </div>
              </div>
              <div className="col-lg-6 img-col">
                <div className="blog-image">
                  <img src={articleImage} alt="alt" />
                  <p>Lorem ipsum dolor sit ame</p>
                  {/* <div className="blog-bottomCard">
                <p >Lorem ipsum dolor sit ame</p>
                </div> */}
                </div>
              </div>
              <div className="blog-center">
                <h1>Parcourir par catégorie</h1>
                <p>
                  Sélectionnez une catégorie pour voir plus de contenu connexe
                </p>
              </div>
              <div className="content">
                {category ? (
                  <div className="button-container">
                    {category.map((val, index) => (
                      <div key={val.id} className="button-wrapper">
                        <button
                          onClick={(e) => handleArticlesChange(e, val.id)}
                        >
                          {val.categoryName}
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <></>
                )}
              </div>

              {/* <div className="content">
                <div>
                <button>Etudes longues</button>
                <button>Etudes longues</button>
                <button>Etudes longues</button>
                </div>
                <div>
                <button>Etudes longues</button>
                <button>Etudes longues</button>
                <button>Etudes longues</button>
                </div>
              </div> */}

              <div className="article-box">
                <span>Koubagla, nous avons trouvé 10 articles pour vous</span>

                <ArticleList items={data} />
                {/* <div className="blog-box">
                <div className="col-lg-12">
                  <Link to="/article">
                    <div className="row mb-4">
                      <div className="flex shadow-xl p-0 rounded-sm">
                        <div className="article-image">
                          <img
                            src={cardImages}
                            alt="alt"
                            className="object-cover"
                          />
                        </div>
                        <div className="col-lg-6 py-6 px-6 shadow-lg rounded-sm ">
                          <div className="articles-cards">
                            <h1>
                              Koubagla, nous avons trouvé 10 articles pour vous
                            </h1>
                            <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit. Curabitur volutpat dui eu risus
                              aucullamcorper. Nunc in mollis turpis. Donec
                              varius, justo ac venenatis lobortis, odio mi
                              vulputate purus, at vehicula enim ante a dui.
                              Phasellus sit amet metus eget turpis posuer
                              <span className="hover:inline font-bold text-[#005073]">
                                ...Read More
                              </span>
                              
                            </p>
                            <p className="mt-3">Author:Tarun kaushal</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="flex shadow-lg p-0">
                        <div className="article-image">
                          <img
                            src={cardImages}
                            alt="alt"
                            className="object-cover"
                          />
                        </div>
                        <div className="col-lg-6 py-6 shadow-md origin-bottom">
                          <div className="articles-cards">
                            <h1>
                              Koubagla, nous avons trouvé 10 articles pour vous
                            </h1>
                            <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit. Curabitur volutpat dui eu risus
                              aucullamcorper. Nunc in mollis turpis. Donec
                              varius, justo ac venenatis lobortis, odio mi
                              vulputate purus, at vehicula enim ante a dui.
                              Phasellus sit amet metus eget turpis posuer
                              <span className="hover:inline font-bold text-[#005073]">
                                ...Read More
                              </span>
          
                            </p>
                            <p className="mt-3">Author:Tarun kaushal</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="flex shadow-lg p-0">
                        <div className="article-image">
                          <img
                            src={cardImages}
                            alt="alt"
                            className="object-cover"
                          />
                        </div>
                        <div className="col-lg-6 py-6 shadow-md origin-bottom">
                          <div className="articles-cards">
                            <h1>
                              Koubagla, nous avons trouvé 10 articles pour vous
                            </h1>
                            <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit. Curabitur volutpat dui eu risus
                              aucullamcorper. Nunc in mollis turpis. Donec
                              varius, justo ac venenatis lobortis, odio mi
                              vulputate purus, at vehicula enim ante a dui.
                              Phasellus sit amet metus eget turpis posuer
                              <span className="hover:inline font-bold text-[#005073]">
                                ...Read More
                              </span>
                            </p>
                            <p className="mt-3">Author:Tarun kaushal</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="flex shadow-xl p-0 rounded-sm">
                        <div className="article-image">
                          <img
                            src={cardImages}
                            alt="alt"
                            className="object-cover"
                          />
                        </div>
                        <div className="col-lg-6 py-6 shadow-lg rounded-sm ">
                          <div className="articles-cards">
                            <h1>
                              Koubagla, nous avons trouvé 10 articles pour vous
                            </h1>
                            <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit. Curabitur volutpat dui eu risus
                              aucullamcorper. Nunc in mollis turpis. Donec
                              varius, justo ac venenatis lobortis, odio mi
                              vulputate purus, at vehicula enim ante a dui.
                              Phasellus sit amet metus eget turpis posuer
                              <span className="hover:inline font-bold text-[#005073]">
                                ...Read More
                              </span>
                            </p>
                            <p className="mt-3">Author:Tarun kaushal</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
}
